var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 16C38.0406 16 38.7189 16.281 39.219 16.781C39.719 17.2811 40 17.9594 40 18.6667V37.3333C40 38.0406 39.719 38.7189 39.219 39.219C38.7189 39.719 38.0406 40 37.3333 40H18.6667C17.9594 40 17.2811 39.719 16.781 39.219C16.281 38.7189 16 38.0406 16 37.3333V18.6667C16 17.9594 16.281 17.2811 16.781 16.781C17.2811 16.281 17.9594 16 18.6667 16H37.3333ZM36.6667 36.6667V29.6C36.6667 28.4472 36.2087 27.3416 35.3936 26.5264C34.5784 25.7113 33.4728 25.2533 32.32 25.2533C31.1867 25.2533 29.8667 25.9467 29.2267 26.9867V25.5067H25.5067V36.6667H29.2267V30.0933C29.2267 29.0667 30.0533 28.2267 31.08 28.2267C31.5751 28.2267 32.0499 28.4233 32.3999 28.7734C32.75 29.1235 32.9467 29.5983 32.9467 30.0933V36.6667H36.6667ZM21.1733 23.4133C21.7674 23.4133 22.3372 23.1773 22.7573 22.7573C23.1773 22.3372 23.4133 21.7674 23.4133 21.1733C23.4133 19.9333 22.4133 18.92 21.1733 18.92C20.5757 18.92 20.0026 19.1574 19.58 19.58C19.1574 20.0026 18.92 20.5757 18.92 21.1733C18.92 22.4133 19.9333 23.4133 21.1733 23.4133ZM23.0267 36.6667V25.5067H19.3333V36.6667H23.0267Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f0057667be1171e42ce029a7d933bbfd.svg";
export { ForwardRef as ReactComponent };